
export const PERSON_MANAGER_GET_LIST = 'SPERSON_MANAGER_GET_LIST';

